<template>
  <Input class="ts-input" v-bind="$attrs" v-on="$listeners"/>
</template>

<style lang="scss" scoped>
.ts-input::v-deep {
  box-shadow: inset -5px -5px 10px 0 #fafbff, inset 5px 5px 10px 0 #a6abbd;
  border-radius: 28px;

  &.input-checked{
    &::after{
      content: "\2713";
      position: absolute;
      right: 0;
      background: #5fe5a8;
      --widthA: calc(100% / 2);
      top: calc(var(--widthA) - 10px);
      display: inline-flex;
      padding: 2px 5px;
      margin-right: 10px;
      border-radius: 10px;
      align-items: center;
      justify-content: center;
    }
    .el-input__inner,
    .el-textarea__inner{
      border-color: #5fe5a8 !important;
      border: 2px solid;
    }
  }

  &.el-input--mini {
    .el-input__inner {
      border-radius: 16px;
      line-height: 18px;
      padding: 6px 16px;
      font-size: 12px;

      &::placeholder {
        font-size: 12px;
      }
    }
  }

  .el-input__inner,
  .el-textarea__inner {
    background: #ebecf0;
    background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
    background-blend-mode: soft-light, normal;
    background-clip: padding-box;
    border: 2px solid rgba(255, 255, 255, 0.4);
    box-shadow: inset -5px -5px 10px 0 #fafbff, inset 5px 5px 10px 0 #a6abbd;
    border-radius: 28px;

    height: auto;
    padding: 6px 16px;

    font-family: Roboto;
    font-size: 16px;
    color: #242424;

    &::placeholder {
      color: #6d7587;
    }

    &:focus {
      border: solid 2px #99ffd1;
    }
  }

  .el-input__suffix {
    display: none;
  }
}
</style>

<script>
import { Input } from 'element-ui';

export default {
  name: 'TsInput',
  props: {
    highlighted: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Input
  }
};
</script>
